<template>
  <el-dialog
    title="导入数据"
    :visible.sync="dialogdata"
    width="620px"
    style="text-align: left"
    :close-on-click-modal="false"
    @open="opendialog"
  >
    <div class="uploadbox">
      <el-upload
        class="avatar-uploader"
        name="image"
        :action="uploadUrl"
        :data="uploadExtraData"
        :headers="uploadHeaders"
        :show-file-list="false"
        :on-success="handleAvatarSuccess"
        :before-upload="beforeUpload"
      >
        <el-button
          plain
          v-if="file_name"
          size="medium"
        >重新选择</el-button>
        <el-button
          type="primary"
          v-else
          size="medium"
        >选择文件</el-button>
      </el-upload>
      <div
        class="filebox"
        v-if="file_name"
      >
        <div>
          <span>上传文件：</span>
          <span style="color: #666">{{ file_name }}</span>
        </div>
        <div style>
          <span>文件大小：</span>
          <span style="color: #666">{{ file_size }}kb</span>
        </div>
        <div>
          <span>成功条数：</span>
          <span style="color: #666">{{ success_count }}条</span>
        </div>
        <div v-if="fail_count">
          <span>错误数据：</span>
          <span style="color: #ff514b">{{ fail_count }}</span>
        </div>
      </div>
      <div class="msgbox">
        <el-button
          type="text"
          @click="download"
        >下载模板</el-button>
        <ul style="color: #999">
          <li>请按照模板格式完整填写数据后导入，否则无法导入</li>
          <li>导入数据将整体替换原有数据</li>
          <!-- <li>最大支持500KB的Excel文件</li> -->
          <li>错误数据可对照文件行数修改数据后重新导入</li>
          <li>导入数据需要时间，请耐心等待</li>
        </ul>
      </div>
    </div>
    <div style="text-align: right; padding: 0 20px 20px 0; box-sizing: border-box">
      <el-button
        type="primary"
        @click="close"
        style="width: 92px"
        size="medium"
      >确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import constant from '../../../service/common/constant';
export default {
  data() {
    return {
      dialogdata: false,
      uploadExtraData: {
        img_type: 6,
        suffix: '.jpg'
      },
      file_name: '',
      file_size: '',
      success_count: '',
      fail_count: '',
      hospital_id: '',
      hospitalList: []
    };
  },
  watch: {
    isFlag() {
      this.dialogdata = true;
    }
  },
  computed: {
    uploadUrl() {
      if (process.env.NODE_ENV == 'development') {
        // 本地开发使用 api 前缀
        return '/api/platform/upload/uploadFile';
      } else {
        return '/platform/upload/uploadFile';
      }
    },
    uploadHeaders: function () {
      return Object.assign(
        {},
        _.pick(constant.HEADERS, ['version', 'platform']),
        {
          timestamp: Date.now(),
          token: this.$store.state.login.headerToken
        }
      );
    }
  },
  props: ['isFlag'],
  methods: {
    //提交
    close() {
      this.dialogdata = false;
    },
    //上传之前
    beforeUpload(file) {
      const isText = file.type === 'application/vnd.ms-excel';
      const isTextComputer =
        file.type ===
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      if (!isText && !isTextComputer) {
        this.$message.error('上传文件只能是CSV或Excel文件');
        return false;
      }
      const suffix = file.name.substring(file.name.lastIndexOf('.'));
      this.uploadExtraData.suffix = suffix;
      return isText || isTextComputer;
    },
    //上传成功
    handleAvatarSuccess(res, file) {
      let loading = this.$loading();
      if (res.code === 0) {
        let data = {
          evaluate_pic: res.data.pic
        };
        this.axios
          .post('platform/doctor/importUserEvaluate', data)
          .then((res) => {
            if (res.code == 0) {
              this.file_name = file.name;
              this.file_size = (file.size / 1024).toFixed(2);
              this.success_count = res.data.success_row_count;
              this.fail_count = res.data.fail_row_count;
             this.$emit('refreshData');
            }
            loading.close();
          })
          .catch((err) => {
            loading.close();
          });
      } else {
        loading.close();
        this.$message.error(res.message);
      }
    },
    //下载模板
    download() {
      let host =
        document.location.protocol +
        '//' +
        window.location.host +
        '/upload/evaluate_pic.xls';
        console.log(host)
      location.href = host;
    },
    opendialog() {
      this.file_name = '';
      this.file_size = '';
      this.success_count = '';
      this.fail_count = '';
    }
  }
};
</script>
<style lang="scss" scoped>
.uploadbox {
  padding: 30px 40px;
  box-sizing: border-box;
}
.filebox {
  line-height: 32px;
}
</style>
